import { createGlobalStyle, fonts, colors, avatarBackground, media } from 'styles'

const GlobalStyles = createGlobalStyle`
  @import url(${fonts.url});
  @import url('https://use.fontawesome.com/releases/v5.2.0/css/all.css');

  body {
    font-family: ${fonts.body};
  }

  .with-filter {
    background-color: ${avatarBackground} !important; /* ordering is different between local & prod */
    background-blend-mode: overlay;
  }

  .online-indicator {
    display: inline-block;
    vertical-align: super;
    margin: .2rem auto 0 0.5rem;
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.5rem;
    border-radius: 100%;
    background: #e93a3c;
    &.online {
      background-color: greenyellow;
    }
  }

  .app-header {
    width: 100%;
    padding: 1rem 0;
    background-color: ${colors.main};
    color: ${colors.mainInverted};
    text-align: center;
    position: relative;

    .logo .text {
      margin: 1rem 0;
    }
  }

  .app-back {
    text-transform: uppercase;
    cursor: pointer;
    position: absolute;
    right: 5rem;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    i {
      font-size: 1.7rem;
      margin-right: 0.5rem;
    }

    ${media.mobile`
      right: 2rem;
    `}

    ${media.phone`
      right: 1rem;
    `}
  }
  .logo img {
    max-height: 6rem;
  }

  .section-title {
    justify-self: self-start;
    margin: 0;
    margin-right: auto;
    color: ${colors.textSectionTitle};
    font: 700 1.8rem ${fonts.title};
    text-transform: uppercase;
  }

  [data-offer-name] a { text-decoration: none; }
  [data-offer-name] p, [data-offer-name] h1, [data-offer-name] h2, [data-offer-name] h3, [data-offer-name] h4, [data-offer-name] h5, [data-offer-name] h6 { margin: 0; }
  #offer-popup-container { z-index: 1000; position: fixed; top: 0; bottom: 0; right: 0; left: 0; }
  #offer-popup-container:empty { display: none; }
  .offer-overlay { position: fixed; top: 0; bottom: 0; right: 0; left: 0; background: rgba(0,0,0,0.8); backdrop-filter: blur(4px); }
  .offer-center { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); }

  html {
    line-height: 1.4;
    -webkit-text-size-adjust: 100%;
    font-size: 10px;
  }

  html, body {
    margin: 0;
    background-color: ${colors.mainBackground};
    color: ${colors.textMain};
  }
  html.modal-open, html.modal-open body {
    overflow: hidden;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  a {
    background-color: transparent;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.4;
    margin: 0;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  textarea {
    overflow: auto;
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }

  [hidden] {
    display: none;
  }

  .hide-for-vip-disabled {
    display: none;
  }
`

export default GlobalStyles
